if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.submitButton = this.querySelector('[type="submit"]');
        this.notifyButton = null;


        setTimeout(()=> {
          if(this.querySelector('.product-form__submit[data-notify="true"]')) {
            this.querySelector('.product-form__submit[data-notify="true"]').classList.remove('notify-locked');
          }
        },2000)

      //   // Notify when available
        this.checkForNotifyWhenAvailable();
        const observer = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
              this.checkForNotifyWhenAvailable(observer);
            }
          }
        });

        observer.observe(document.body, {childList: true, subtree: true});
      }

      checkForNotifyWhenAvailable(observer) {
        this.omnisendForms = document.querySelectorAll(`[id^='omnisend-form']`);
        for (const form of this.omnisendForms) {
          if (
            form.tagName.toLowerCase() === "button" &&
            form.innerHTML.toLowerCase().includes("notify me when available")
          ) {
            form.parentElement.style.display = "none";
            this.querySelector('.product-form__submit[data-notify="true"]').addEventListener('click',(e) => {
              e.preventDefault();
              form.click();
            })
            if (observer) {
              observer.disconnect();
            }
            break;
          }
        }
      }

      // loop through the ajax cart current items
      addCompareAtPrice(cart) {
        return new Promise((resolve) => {
          let counter = 0;
          cart.items.forEach((item, index, array) => {
            fetch(`/products/${item.handle}/.js`)
              .then((res) => {
                return res.json();
              })
              .then((product) => {
                counter++;
                product.variants.forEach((variant) => {
                  if (
                    variant.compare_at_price != null &&
                    variant.id == item.variant_id
                  )
                    item["compare_at_price"] = variant.compare_at_price;
                  else item["compare_at_price"] = 0;
                });
                if (counter === array.length) {
                  resolve(cart);
                }
              });
          });
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // Notify when available
        if (this.notifyButton) {
          this.notifyButton.click();
          return;
        }

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.setAttribute("disabled", true);
        this.submitButton.textContent = window.variantStrings.loading;

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        const {frequentlyBoughtTogether} = window["@algolia/recommend-js"];
        const rec = window["@algolia/recommend"];

        const frequentClient = algoliasearch(
          "MB13IY345Y",
          "5a50c24f3e92ae83f808068a942a1f3b",
        );
        const fidx = frequentClient.initIndex("shopify_products");

        const recommendFreqClient = rec(
          "MB13IY345Y",
          "5a50c24f3e92ae83f808068a942a1f3b",
        );

        // use the api to get the correct Algolia object ID by passing the product ID
        const generateFrequentObjectID = () => {
          const id = document
            .querySelector("#frequent-products")
            .getAttribute("data-product-id");

          return new Promise((resolve, reject) => {
            fetch("/cart.js")
              .then((res) => {
                return res.json();
              })
              .then((res) => {
                return res.items;
              })
              .then((res) => {
                let ids = [];
                res.map((i) => {
                  return ids.push(`${i.product_id}`);
                });
                // console.log(ids);
                fidx.search(ids).then(({hits}) => {
                  resolve(hits);
                  return hits;
                });
              });
          });
        };

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              this.submitButton.textContent = window.variantStrings.unavailable;
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    // this.handleCartData(response);
                    this.handleCartData(response.sections, config);
                  });
                },
                {once: true},
              );
              quickAddModal.hide(true);
            } else {
              // this.cartNotification.renderContents(response);
              this.handleCartData(response.sections, config);
            }
          })
          .then(() => {
            generateFrequentObjectID().then((data) => {
              let idsToSearch = data.map((i) => i.objectID);
              frequentlyBoughtTogether({
                container: "#frequent-products",
                recommendClient: recommendFreqClient,
                indexName: "shopify_products",
                maxRecommendations: 4,
                objectIDs: idsToSearch,
                headerComponent(props) {
                  if (props.recommendations.length == 0) {
                    document
                      .querySelector("#sidecart-products-recommends")
                      .classList.add("hidden");
                  } else {
                    document
                      .querySelector("#sidecart-products-recommends")
                      .classList.remove("hidden");
                  }
                },
                itemComponent({item, createElement}) {
                  return createElement(
                    "a",
                    {
                      className:
                        "card-product card-carousel-js swiper-slide frequent-product-card",
                      href: `/products/${item.handle}`,
                      "data-type": `trending`,
                    },
                    createElement(
                      "img",
                      {
                        className: "trending-product-img card-product__image",
                        src: item.image,
                        style: `width: 100px`,
                      },
                      item.image,
                    ),
                    createElement(
                      "div",
                      {
                        className: "frequent-product-details",
                      },
                      createElement(
                        "h4",
                        {
                          className:
                            "frequent-product-name card-product__heading",
                        },
                        item.title,
                      ),
                      createElement(
                        "span",
                        {
                          className:
                            "card-product__price frequent-product-price",
                        },
                        `£${item.price}`,
                      ),
                    ),
                  );
                },
              });
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          });
      }

      handleCartData(sections, config) {
        // fetch the ajax cart object
        fetch(`${routes.cart_url}`, config)
          // return the data as valid JSON
          .then((response) => response.json())
          .then((response) => this.addCompareAtPrice(response))
          .then((response) => {
            this.cartNotification.renderContents(
              response.items,
              sections,
              "full-cart",
              false,
              response.total_price,
            );
            this.submitButton.textContent = window.variantStrings.addToCart;
            this.submitButton.removeAttribute("disabled", true);

            // pre fil the data attribute for promo message
            let watch = document.querySelector(
              "#deal-message-notification-sidecart",
            )
              ? document.querySelector("#deal-message-notification-sidecart")
                  .dataset.dealIds
              : null;

            if (watch) {
              let promos = document.querySelector(
                "#deal-message-notification-sidecart",
              ).dataset.promoIds;

              let _ids = watch.split(",");
              _ids.pop();

              let _pids = promos.split(",");
              _pids.pop();

              let c = 0;

              let cartIDS = response.items.map((i) => {
                return {id: i.id.toString(), q: i.quantity};
              });

              cartIDS.map((i) => {
                // console.log(i);
                if (_ids.includes(i.id)) {
                  c += i.q;
                }
                if (_pids.includes(i.id)) {
                  document
                    .querySelector("#deal-message-notification-sidecart")
                    .setAttribute("data-deal-ready", true);
                }
              });

              let full_cart_ids = [];

              let line_item_ids = response.items.map((i) => {
                return i.id.toString();
              });

              // console.log(line_item_ids);

              document
                .querySelector("#deal-message-notification-sidecart")
                .setAttribute("data-count", c);
              document
                .querySelector("#deal-message-notification-sidecart")
                .setAttribute("data-cart-ids", line_item_ids);
            }
          })
          .catch((e) => {
            console.error(e);
          });
        return;
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.parentElement.querySelector(
            ".product-form__error-message-wrapper",
          );

        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.querySelector(".product-form__submit:not(.related-products-popup-basket-btn-js)");
  const productForm = document.querySelector(".product-form:not(.ignore-notify)");
  const variantRadios = document.querySelector(".variant-radios");
  const noticeMessage = document.querySelector(".product-form-option-notice");

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.getAttribute("disabled") == "true") {
        productForm.classList.add("button-disabled");
      } else {
        productForm.classList.remove("button-disabled");
      }
    });
  });

  // observer.observe(addToCartButton, {
  //   attributes: true,
  // });

  // if (addToCartButton.hasAttribute("disabled")) {
  //   productForm.classList.add("button-disabled");
  // }

  productForm.addEventListener("click", function () {
    if (addToCartButton.hasAttribute("disabled")) {
      variantRadios.classList.add("highlight");
      noticeMessage.classList.add("active");
      productForm.classList.remove("button-disabled");

      setTimeout(() => {
        variantRadios.classList.remove("highlight");
        noticeMessage.classList.remove("active");
        productForm.classList.add("button-disabled");
      }, 3000);
    }
  });

  addToCartButton.addEventListener("click", function () {
    variantRadios.classList.remove("highlight");
    noticeMessage.classList.remove("active");
  });

  function checkURLParams() {
    let urlParams = new URLSearchParams(window.location.search);

    // Check if there are any parameters
    if (urlParams.toString() !== "") {
      // Iterate over each parameter
      urlParams.forEach(function (value, key) {
        if (key === "variant") {
          let variantId = value;
          // Loop over .variant-radios__input-wrapper elements
          document
            .querySelectorAll("#variant-popup .variant-radios__input-wrapper")
            .forEach(function (inputWrapper) {
              // Check if the input data-variant-id matches the variantId
              let input = inputWrapper.querySelector(
                'input[data-variant-id="' + variantId + '"]',
              );
              if (input) {
                inputWrapper.click();
              }
            });
        }
      });
    }
  }

  checkURLParams();

  let currentParams = window.location.search;
  setInterval(function () {
    let newParams = window.location.search;
    if (newParams !== currentParams) {
      checkURLParams();
      currentParams = newParams;
    }
  }, 300);
});
